/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { camelCaseToRegularForm, capitalizeFirstLetter } from 'serenova-js-utils/strings';

import styled from 'styled-components';
import { SearchIconSVG,FilterSelect } from 'cx-ui-components';

const Input = styled.input`
  width: 100%;
`;
const SearchIcon = styled(SearchIconSVG)`
  position: relative;
  left: -17px;
  opacity: 0.4;
`;

export function requestTypeColumn(string, customString) {
  const normalizedString = customString ? camelCaseToRegularForm(customString) : camelCaseToRegularForm(string);
  const column = {
    id: string,
    Header: <span title={normalizedString}>{normalizedString}</span>,
    accessor: string,
    Cell: ({ row }) => {
        return <span title={row[string]}>{row[string]}</span>; 
    },
    Filter: ({ filter, onChange }) => (
        <FilterSelect
        tableType="modal"
        onChange={(event) => onChange(event.target.value)}
        value={filter ? filter.value : 'all'}
        options={['all', 'Delete', 'Move to Archive', 'Retrieve from Archive','Add Lock','Remove Lock']}
      />
    ),
    filterMethod: (filter, row) => {
        if (filter.value === 'all') {
          return true;
        }
        if (filter.value === 'Delete') {
          return row[filter.id].toLowerCase() === 'delete';
        }
        /*Below are the regex to replace space with the string */
        if (filter.value === 'Move to Archive') {
          return row[filter.id].replace(/[^\w\s]/gi, '').toLowerCase() === 'movetoarchive';
        }
        if (filter.value === 'Add Lock') {
          return row[filter.id].replace(/[^\w\s]/gi, '').toLowerCase() === 'addlock';
        }
        if (filter.value === 'Retrieve from Archive') {
          return row[filter.id].replace(/[^\w\s]/gi, '').toLowerCase() === 'retrievefromarchive';
        }
        if (filter.value === 'Remove Lock') {
          return row[filter.id].replace(/[^\w\s]/gi, '').toLowerCase() === 'removelock';
        }
      },
  };
  column.Cell.propTypes = {
    row: PropTypes.any
  };
  column.Filter.propTypes = {
    filter: PropTypes.func,
    onChange: PropTypes.func
  };

  return column;
}
